export const AGENT_ACTIVITIES_START = 'AGENT_ACTIVITIES_START';
export const AGENT_ACTIVITIES_SUCCESS = 'AGENT_ACTIVITIES_SUCCESS';
export const AGENT_ACTIVITIES_ERROR = 'AGENT_ACTIVITIES_ERROR';
